document.addEventListener("DOMContentLoaded", async () => {
  const t = await i18next.init({
    lng: "es",
    resources: {
      es: {
        translation: {
          heading: "Plan de longevidad de {{name}}",
          subtitle:
            "Hemos recopilado todas las respuestas que nos has dado y hemos creado el plan perfecto para {{name}}.",
          why_label: "Por qué este plan es ideal para {{name}}",
        },
      },
    },
  });

  const quizAnswers = QuizStorage.getQuizAnswers();
  const params = new URLSearchParams(location.search);
  const name = quizAnswers?.name || params.get("name") || "";
  const gender = quizAnswers?.gender || params.get("gender") || "";
  document.querySelector(".plan-section .plan-heading").textContent = t(
    "heading",
    {
      context: gender,
      name,
    },
  );

  document.querySelector(
    ".plan-section .plan-subtitle-row .plan-subtitle",
  ).textContent = t("subtitle", {
    context: gender,
    name,
  });

  document.querySelector(".why-banner .why-label").textContent = t("why_label", {
    context: gender,
    name,
  });
});
